"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var mountIsland_1 = require("../mountIsland");
var MinistrySidebar_1 = __importDefault(require("./MinistrySidebar"));
function WrappedMinistrySidebar() {
    return (react_1.default.createElement(react_router_dom_1.BrowserRouter, null,
        react_1.default.createElement(MinistrySidebar_1.default, null)));
}
document.addEventListener('DOMContentLoaded', function () {
    var container = document.getElementById('ministry-vertical-sidebar');
    if (container) {
        (0, mountIsland_1.mountIsland)(container, react_1.default.createElement(WrappedMinistrySidebar, null));
    }
});
